import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  // Sit above the mobile bottom bar when the page has one, otherwise hug the bottom edge.
  const [aboveNav, setAboveNav] = useState(true);
  useEffect(() => {
    setAboveNav(!!document.querySelector('[data-testid="public-bottom-nav"]'));
  }, []);
  const offset = aboveNav ? "bottom-[calc(4.75rem+env(safe-area-inset-bottom))]" : "bottom-[calc(1rem+env(safe-area-inset-bottom))]";
  return (
    <a
      href="https://wa.me/34632628051?text=Hi%20Steve!%20I'm%20interested%20in%20Savi%20Coliving.%20Do%20you%20have%205%20mins%20to%20chat?"
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed ${offset} md:bottom-6 right-4 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white pl-3 pr-4 py-2.5 min-h-[44px] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group`}
      aria-label="Chat with Steve on WhatsApp"
      data-testid="whatsapp-floating-btn"
    >
      <div className="relative">
        <MessageCircle className="w-5 h-5" />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-green-300 rounded-full border border-[#25D366]" />
      </div>
      <span className="hidden sm:inline font-medium text-sm">Chat with Steve</span>
    </a>
  );
};

export default WhatsAppButton;
